<div>
  <app-scenario-hud [hudIndex]="hudIndex" />
  <div
    id="scenarioLineChart"
    class="scenario-line-chart tw-bg-dt-surface-elevated tw-rounded-b-3xl"
  ></div>
</div>
